import { TReduxActions } from '../../../common/actions';
import { EMapSelectionActionType } from '../../../common/actions/mapSelection/types';
import { IMapSelection, TMapSelection } from '../../types/mapSelection';

export const defaultState: TMapSelection = null;

export function selectionReducer(state: TMapSelection = defaultState, action: TReduxActions): TMapSelection {
  switch (action.type) {
    case EMapSelectionActionType.Changed:
      if (action.payload === null) {
        return null;
      }

      return hasSelectedOffer(action.payload) ? action.payload : state;

    case EMapSelectionActionType.FeatureUpdated:
      // Пересборка геометрии не должна менять выбор или восстанавливать закрытое превью.
      if (!state || state.realtyId !== action.payload.realtyId) {
        return state;
      }

      return hasSelectedOffer(action.payload) ? action.payload : state;

    default:
      return state;
  }
}

function hasSelectedOffer({ realtyId, feature }: IMapSelection): boolean {
  return feature.properties.offers.some(offer => offer.realtyId === realtyId);
}
